<template >
  <IndicationSlot>
    <NextButtom
      btnType="skip"
      styleValue="transform:scale(.5);"
      @click.native="skipEvent()"
      :vertical="false"
      verticalPX="0"
      :horizontal="false"
      horizontalPX="0"
    />
    <!-- 集运按钮 -->
    <div class="start" v-if="step===-1">
      <TalkBox
        :content="$t('indication.jiyun.first')"
        :widthStyle="280"
        styleValue="transform: skew(-8deg);"
        verticalPX="202"
        horizontalPX="573"
      />
      <NextButtom
        styleValue="transform:scale(.7);"
        @click.native="nextEvent"
        verticalPX="410"
        horizontalPX="304"
      />
      <IndicationStatic
        styleValue="transform: scaleY(.5) rotateY(180deg) rotateZ(199deg) skew(22deg);"
        verticalPX="0"
        horizontalPX="673"
        :shapeInfo="{x:'-45px',y:'-2px',w:'183px', h:'257px'}"
      />
    </div>

    <!-- 侧边导航栏步骤     6-12 -->
    <div class="step0" v-else-if="step===0||(step>5 && step<=end)">
      <TalkBox
        :content="calcNavIntro"
        widthStyle="407"
        styleValue="transform: skew(-8deg);"
        textStyle="transform:  skewX(-10deg); text-shadow: 1px 1px 1px  #fff;"
        verticalPX="160"
        horizontalPX="220"
      />
      <div class="scaleBox">
        <div class="circle"></div>
      </div>
      <IndicationStatic
        styleValue="transform: rotateY(30deg);"
        :shapeInfo="{x:'2px',y:'-391px',w:'193px', h:'202px'}"
        verticalPX="222"
        horizontalPX="750"
      />
      <IndicationStatic
        class="shake"
        :shapeInfo="{x:'-122px',y:'-732px',w:'93px', h:'113px'}"
        verticalPX="420"
        horizontalPX="80"
      />
      <NextButtom
        :btnType="end===step?'finish':'next'"
        styleValue="transform:scale(.7);"
        @click.native="nextEvent"
        verticalPX="410"
        horizontalPX="304"
      />
    </div>
    <!-- jiyun 内容指示  1-5 -->
    <div class="step1" v-else-if="step>=1 && step<=5">
      <TalkBox
        :content="formIntro[step-1]"
        widthStyle="337"
        styleValue="transform: skew(-8deg);"
        textStyle="transform:  skewX(-10deg); text-shadow: 1px 1px 1px  #fff;"
        verticalPX="365"
        horizontalPX="280"
      />
      <IndicationStatic
        styleValue="transform: rotateY(30deg) rotateY(180deg);"
        :shapeInfo="{x:'2px',y:'-391px',w:'193px', h:'202px'}"
        verticalPX="365"
        horizontalPX="85"
      />
      <IndicationStatic
        :class="'finger'+step"
        :shapeInfo="{x:'-122px',y:'-732px',w:'93px', h:'113px'}"
        verticalPX="80"
        horizontalPX="190"
      />
      <NextButtom
        styleValue="transform:scale(.7);"
        @click.native="nextEvent"
        verticalPX="200"
        horizontalPX="619"
      />
      <div v-for="i in 3" :key="i" v-show="step===i" :class="'border'+i"></div>
    </div>

    <!-- <TalkBox
      :content="[
      {word:'嘿', style:'transform: skew(50deg);font-size:20px;' },
      {word:'嘿' ,style:'font-size:20px;'},
      {word:'嘿' ,style:'transform:rotate(180deg); font-size:20px;'},
      {word:'嘿' ,style:'transform:rotateX(59deg); font-size:20px;'},
      {word:'嘿' ,style:'transform:rotateY(180deg); font-size:20px;'}
      ]"
      :shapeInfo="{ w:'337px', h:'43px'}"
      styleValue="transform: skew(-8deg);"
      verticalPX="222"
      horizontalPX="30"
    />-->
    <!-- <IndicationStatic
      verticalPX="332"
      horizontalPX="53"
      :shapeInfo="{x:'-45px',y:'-2px',w:'183px', h:'257px'}"
    />-->
  </IndicationSlot>
</template> 
<script>
import NextButtom from "@/components/indication/compose/NextButtom";
import IndicationStatic from "@/components/indication/compose/IndicationStatic";
import TalkBox from "@/components/indication/compose/TalkBox";
import IndicationSlot from "@/components/indication/IndicationSlot";
export default {
  data() {
    // const formIntro = [
    //   "按此選擇賣家發貨的物流公司（ 無則選其他 ）",
    //   "這裏輸入賣家發貨的物流單號",
    //   "這裏具體準確的輸入貨品名稱，我們將會用於海關申報",
    //   "然後按這裏送出就認領完成了",
    //   "之後選取需要集運的貨品，按這裏就可以下單了"
    // ];

    // const navIntro = [
    //   "認領貨品及貨品清單由此進入",
    //   "這裏可以查看三個月內的所有訂單信息",
    //   "這裏可以把自已買的寶貝分享給淘友，並且經多寶審核可獲積分獎勵（ 積分可用於抵扣運費 ）",
    //   "這裏可以看到我分享的全部寶貝",
    //   "這裏可以回復淘友的留言",
    //   "這裏可以查看集運地址及修改帳戶資料",
    //   "這裏可以看到帳戶的可用積分，也可以兌換獲得的積分兌換碼",
    //   "如果你使用的不是私人電腦，用完之後記得按此退出系統"
    // ];

    return {
      formIntro: this.$t("indication.jiyun.formIntro"),
      navIntro: this.$t("indication.jiyun.navIntro"),
      step: -1, // 起始
      end: 12 //结束
    };
  },
  mounted() {
    //  指定到达的位置
  },
  computed: {
    calcNavIntro() {
      let index = 0;
      if (this.step !== 0) {
        index = this.step - 5;
      }
      console.log(index);
      return this.navIntro[index];
    }
  },
  methods: {
    nextEvent(e) {
      this.step++;
      if (this.step > this.end) {
        this.skipEvent();
      }
    },
    skipEvent(e) {
      this.$store.commit("indication/read", this.$route.path);
    }
  },
  watch: {
    step() {
      //导航栏
      const offsets = [0, 100, 100, 100, 186, 400];
      //侧边栏其他

      offsets.push(...[50, 156, 206, 256, 362, 412, 462, 512]);
      const offset = offsets[this.step] ? offsets[this.step] : 0;
      document.body.scrollTop = offset;
      document.documentElement.scrollTop = offset;
    }
  },
  components: {
    IndicationSlot,
    NextButtom,
    IndicationStatic,
    TalkBox
  }
};
</script>
<style lang='stylus' scoped>
.step0 {
  @keyframes shake {
    100% {
      transform: rotateX(30deg) rotateZ(-20deg);
    }
  }

  @keyframes scale {
    100% {
      transform: scale(10);
    }
  }

  .scaleBox {
    .circle {
      transform: scale(0);
      animation: scale 1s ease 1s infinite;
      height: 30px;
      width: 30px;
      left: 126px;
      top: 15px;
      position: relative;
      border-radius: 50%;
      background-image: radial-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));
    }

    z-index: -1;
    height: 50px;
    width: 220px;
    left: 0px;
    top: 386px;
    overflow: hidden;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
  }

  .shake {
    transform: rotateZ(-20deg);
    animation: shake 1s linear infinite;
  }
}

.step1 {
  finger($left, $top, $row = true) {
    transition: all 0.5s;
    left: $left !important;
    top: $top !important;

    if ($row) {
      transform: rotateX(180deg) rotateZ(70deg);
    }
  }

  // 手指样式  不需要不定义
  .finger1 {
    finger(140px, 80px);
  }

  .finger2 {
    finger(460px, 80px);
  }

  .finger3 {
    finger(140px, 150px);
  }

  .finger4 {
    finger(290px, 170px, false);
  }

  .finger5 {
    @keyframes gradually {
      0% {
        opacity: 0.5;
        left: 738px;
        top: 66px;
      }

      100% {
        opacity: 1;
      }
    }

    animation: gradually 2s linear 1 alternate forwards;
    finger(738px, 80px, false);
  }

  borderBox($left, $top, $width, $height = 40px) {
    border-radius: 4px;
    border: 1px solid #fff;
    z-index: 11;
    box-sizing: border-box;
    height: $height;
    width: $width;
    position: absolute;
    left: $left;
    top: $top;
    z-index: -1;
  }

  .border1 {
    borderBox(349px, 101px, 211px);
  }

  .border2 {
    borderBox(661px, 101px, 269px);
  }

  .border3 {
    borderBox(349px, 169px, 581px);
  }
}
</style>
